import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import styled, { keyframes } from "styled-components";
import { Colors } from "../../utils/colors";
import "../../utils/font-family";
import { FiMenu } from "react-icons/fi";
import { Logo } from "../../assets/svg";
import { Link} from "gatsby";

import Data from "../../utils/data";

const headerSlideDown = keyframes`
 0% { top: -100px; }
 100% { top: 0; }
`;
const HeaderWrapper = styled.header<{ background?: boolean }>`
  position: fixed;
  width: 100%;
  background: ${(props) => (props.background ? "#F9FDFF" : "white")};
  border: ${(props) => (props.background ? "0.5px solid #E3E3E3" : "none")};
  z-index: 9;
  &.stickyheader {
    position: fixed;
    padding: 0;
    background-color: rgba(255, 255, 255, 0.65);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 20px 0 rgb(0 0 0 / 10%);
    animation: ${headerSlideDown} 0.95s ease forwards;
  }
`;

const List = styled.ul`
  width: 75%;
  justify-content: space-around;
`;
const ListItem = styled.li<{ isActive: boolean }>`
  list-style: none;
  a {
    text-decoration: none;
    font-family: "Poppins", sans-serif;
    color: ${(prop) => (prop.isActive ? Colors.primaryColor : "#5c5c5c")};
    font-size: 17px;
    padding: 0 12px;
    line-height: 24px;
    letter-spacing: 0.01em;
    font-weight: 500;
    font-style: normal;
    text-transform: capitalize;
    :hover {
      color: ${Colors.primaryColor};
    }
  }
`;

const SiteLogo = styled.div`
  @media (max-width: 575px) {
    a {
      svg {
        width: 100% !important;
        height: 100% !important;
        max-width: 150px;
      }
    }
  }
`;
const RightMenu = styled.div`
  @media (max-width: 575px) {
    svg {
      height: 33px !important;
      width: 29px !important;
    }
  }
`;
interface Props {
  from: string;
  setCanvas: Dispatch<SetStateAction<boolean>>;
  background?: boolean;
}

const Header = ({ setCanvas, background }: Props) => {
  const [headerSticky, setheaderSticky] = useState(false);
  let location: string;
  const isBrowser = typeof window !== "undefined";
  if (isBrowser) {
    location = window.location.pathname;
  } else {
    location = "/";
  }
  const strapiGlobal = Data();

  useEffect(() => {
    function scrollFunction() {
      if (window.pageYOffset > 100) {
        setheaderSticky(true);
      } else {
        setheaderSticky(false);
      }
    }
    window.addEventListener("scroll", scrollFunction);
  }, []);

  return (
    <>
      {/* <TopNotification className="d-flex justify-content-center pt-1 pb-1">Free Service is available for first 100 users!</TopNotification> */}
      <HeaderWrapper
        className={headerSticky ? "stickyheader" : ""}
        background={background}
      >
        <div className="container">
          <nav className="d-flex justify-content-between align-items-center py-4">
            <SiteLogo>
              <Link to="/" aria-label="stagro">
                <Logo />
              </Link>
            </SiteLogo>
            <List className="d-none d-lg-flex text-decoration-none justify-content-between mb-0 ps-0">
              {strapiGlobal.strapiLayout.navbar.map(
                (item: any, index: number) => {
                  return (
                    <ListItem
                      key={index}
                      isActive={location === item.navbarLink.split("?")[0]}
                    >
                      <Link to={item.navbarLink}>{item.navbarItem}</Link>
                    </ListItem>
                  );
                }
              )}
            </List>
            <RightMenu
              className=" fs-1"
              onClick={() => setCanvas(true)}
              style={{cursor:"pointer"}}
            >
              <FiMenu />
            </RightMenu>
          </nav>
        </div>
      </HeaderWrapper>
    </>
  );
};

export default Header;